module.exports = __webpack_public_path__ + "images/background/image/4-81bdfa6cd2846d5135f34510a83165bd.jpg";